/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Rocket.net API
 * Rocket.net - All APIs
 * OpenAPI spec version: 1.0.0
 */
import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import { customFetch } from '../../custom-fetch';
import { addMetaToQuery } from '../../mutators/add-meta';
import type {
  BandwidthTopUsageResponse,
  BandwidthUsageReportingResponse,
  CDNCacheContentResponse,
  CDNCacheStatusResponse,
  CDNCacheTopResponse,
  CDNRequestVolumeBySourceResponse,
  CDNVisitorsResponse,
  Error,
  ListAccessLogsResponse,
  ListSiteAccessLogsAliasDeprecatedParams,
  ListSiteAccessLogsParams,
  ListWAFEventsResponse,
  ReportOnReportingSiteBandwidthUsageParams,
  ReportOnSiteBandwidthTopUsageParams,
  ReportOnSiteCdnCacheContentParams,
  ReportOnSiteCdnCacheStatusParams,
  ReportOnSiteCdnCacheTopDeprecatedParams,
  ReportOnSiteCdnRequestVolumeBySourceParams,
  ReportOnSiteCdnRequests200,
  ReportOnSiteCdnRequestsParams,
  ReportOnSiteTotalRequestsParams,
  ReportOnSiteVisitorsParams,
  ReportOnSiteWafEventlistParams,
  ReportOnSiteWafEventsDeprecatedParams,
  ReportOnSiteWafEventsServicesDeprecatedParams,
  ReportOnSiteWafEventsSourceParams,
  ReportOnSiteWafEventsStatsParams,
  ReportOnSiteWafEventsTimeParams,
  ReportOnSiteWafFirewallEventsDeprecatedParams,
  SiteID,
  TotalRequestsResponse,
  WAFEventsResponse,
  WAFEventsServicesResponse,
  WAFEventsStatsResponse,
  WAFEventsTimeResponse,
  WAFFirewallEventsResponse,
  WAFFirewallEventsSourceResponse,
} from '../rocketNetAPI.schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * Returns highest bandwidth users grouped by IP, URL, country, and similar dimensions.
 * @summary Get top bandwidth consumers
 */
export const reportOnSiteBandwidthTopUsage = (
  id: SiteID,
  params: ReportOnSiteBandwidthTopUsageParams,
  signal?: AbortSignal
) => {
  return customFetch<BandwidthTopUsageResponse>({
    url: `/v1/reporting/sites/${id}/bandwidth/top-usage`,
    method: 'GET',
    params,
    signal,
  });
};

export const getReportOnSiteBandwidthTopUsageQueryKey = (
  id?: SiteID,
  params?: ReportOnSiteBandwidthTopUsageParams
) => {
  return [`/v1/reporting/sites/${id}/bandwidth/top-usage`, ...(params ? [params] : [])] as const;
};

export const getReportOnSiteBandwidthTopUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteBandwidthTopUsage>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteBandwidthTopUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteBandwidthTopUsage>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReportOnSiteBandwidthTopUsageQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportOnSiteBandwidthTopUsage>>> = ({
    signal,
  }) => reportOnSiteBandwidthTopUsage(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/reporting/sites/${id}/bandwidth/top-usage`,
      operationId: 'app.controllers.reporting_controller.report_on_site_bandwidth_top_usage',
      operationName: 'reportOnSiteBandwidthTopUsage',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteBandwidthTopUsage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteBandwidthTopUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteBandwidthTopUsage>>
>;
export type ReportOnSiteBandwidthTopUsageQueryError = Error;

export function useReportOnSiteBandwidthTopUsage<
  TData = Awaited<ReturnType<typeof reportOnSiteBandwidthTopUsage>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteBandwidthTopUsageParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteBandwidthTopUsage>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteBandwidthTopUsage>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteBandwidthTopUsage>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteBandwidthTopUsage<
  TData = Awaited<ReturnType<typeof reportOnSiteBandwidthTopUsage>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteBandwidthTopUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteBandwidthTopUsage>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteBandwidthTopUsage>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteBandwidthTopUsage>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteBandwidthTopUsage<
  TData = Awaited<ReturnType<typeof reportOnSiteBandwidthTopUsage>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteBandwidthTopUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteBandwidthTopUsage>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get top bandwidth consumers
 */

export function useReportOnSiteBandwidthTopUsage<
  TData = Awaited<ReturnType<typeof reportOnSiteBandwidthTopUsage>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteBandwidthTopUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteBandwidthTopUsage>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteBandwidthTopUsageQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getReportOnSiteBandwidthTopUsageSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteBandwidthTopUsage>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteBandwidthTopUsageParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteBandwidthTopUsage>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReportOnSiteBandwidthTopUsageQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportOnSiteBandwidthTopUsage>>> = ({
    signal,
  }) => reportOnSiteBandwidthTopUsage(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/reporting/sites/${id}/bandwidth/top-usage`,
      operationId: 'app.controllers.reporting_controller.report_on_site_bandwidth_top_usage',
      operationName: 'reportOnSiteBandwidthTopUsage',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteBandwidthTopUsage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteBandwidthTopUsageSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteBandwidthTopUsage>>
>;
export type ReportOnSiteBandwidthTopUsageSuspenseQueryError = Error;

export function useReportOnSiteBandwidthTopUsageSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteBandwidthTopUsage>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteBandwidthTopUsageParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteBandwidthTopUsage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteBandwidthTopUsageSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteBandwidthTopUsage>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteBandwidthTopUsageParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteBandwidthTopUsage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteBandwidthTopUsageSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteBandwidthTopUsage>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteBandwidthTopUsageParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteBandwidthTopUsage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get top bandwidth consumers
 */

export function useReportOnSiteBandwidthTopUsageSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteBandwidthTopUsage>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteBandwidthTopUsageParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteBandwidthTopUsage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteBandwidthTopUsageSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns time-series requests, bandwidth, and visitors with period totals.
 * @summary Get bandwidth and traffic trends
 */
export const reportOnReportingSiteBandwidthUsage = (
  id: SiteID,
  params: ReportOnReportingSiteBandwidthUsageParams,
  signal?: AbortSignal
) => {
  return customFetch<BandwidthUsageReportingResponse>({
    url: `/v1/reporting/sites/${id}/bandwidth/usage`,
    method: 'GET',
    params,
    signal,
  });
};

export const getReportOnReportingSiteBandwidthUsageQueryKey = (
  id?: SiteID,
  params?: ReportOnReportingSiteBandwidthUsageParams
) => {
  return [`/v1/reporting/sites/${id}/bandwidth/usage`, ...(params ? [params] : [])] as const;
};

export const getReportOnReportingSiteBandwidthUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnReportingSiteBandwidthUsage>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnReportingSiteBandwidthUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reportOnReportingSiteBandwidthUsage>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getReportOnReportingSiteBandwidthUsageQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportOnReportingSiteBandwidthUsage>>> = ({
    signal,
  }) => reportOnReportingSiteBandwidthUsage(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/reporting/sites/${id}/bandwidth/usage`,
      operationId: 'app.controllers.reporting_controller.report_on_reporting_site_bandwidth_usage',
      operationName: 'reportOnReportingSiteBandwidthUsage',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof reportOnReportingSiteBandwidthUsage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnReportingSiteBandwidthUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnReportingSiteBandwidthUsage>>
>;
export type ReportOnReportingSiteBandwidthUsageQueryError = Error;

export function useReportOnReportingSiteBandwidthUsage<
  TData = Awaited<ReturnType<typeof reportOnReportingSiteBandwidthUsage>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnReportingSiteBandwidthUsageParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reportOnReportingSiteBandwidthUsage>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnReportingSiteBandwidthUsage>>,
          TError,
          Awaited<ReturnType<typeof reportOnReportingSiteBandwidthUsage>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnReportingSiteBandwidthUsage<
  TData = Awaited<ReturnType<typeof reportOnReportingSiteBandwidthUsage>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnReportingSiteBandwidthUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reportOnReportingSiteBandwidthUsage>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnReportingSiteBandwidthUsage>>,
          TError,
          Awaited<ReturnType<typeof reportOnReportingSiteBandwidthUsage>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnReportingSiteBandwidthUsage<
  TData = Awaited<ReturnType<typeof reportOnReportingSiteBandwidthUsage>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnReportingSiteBandwidthUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reportOnReportingSiteBandwidthUsage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get bandwidth and traffic trends
 */

export function useReportOnReportingSiteBandwidthUsage<
  TData = Awaited<ReturnType<typeof reportOnReportingSiteBandwidthUsage>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnReportingSiteBandwidthUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reportOnReportingSiteBandwidthUsage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnReportingSiteBandwidthUsageQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getReportOnReportingSiteBandwidthUsageSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnReportingSiteBandwidthUsage>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnReportingSiteBandwidthUsageParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnReportingSiteBandwidthUsage>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getReportOnReportingSiteBandwidthUsageQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportOnReportingSiteBandwidthUsage>>> = ({
    signal,
  }) => reportOnReportingSiteBandwidthUsage(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/reporting/sites/${id}/bandwidth/usage`,
      operationId: 'app.controllers.reporting_controller.report_on_reporting_site_bandwidth_usage',
      operationName: 'reportOnReportingSiteBandwidthUsage',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof reportOnReportingSiteBandwidthUsage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnReportingSiteBandwidthUsageSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnReportingSiteBandwidthUsage>>
>;
export type ReportOnReportingSiteBandwidthUsageSuspenseQueryError = Error;

export function useReportOnReportingSiteBandwidthUsageSuspense<
  TData = Awaited<ReturnType<typeof reportOnReportingSiteBandwidthUsage>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnReportingSiteBandwidthUsageParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnReportingSiteBandwidthUsage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnReportingSiteBandwidthUsageSuspense<
  TData = Awaited<ReturnType<typeof reportOnReportingSiteBandwidthUsage>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnReportingSiteBandwidthUsageParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnReportingSiteBandwidthUsage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnReportingSiteBandwidthUsageSuspense<
  TData = Awaited<ReturnType<typeof reportOnReportingSiteBandwidthUsage>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnReportingSiteBandwidthUsageParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnReportingSiteBandwidthUsage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get bandwidth and traffic trends
 */

export function useReportOnReportingSiteBandwidthUsageSuspense<
  TData = Awaited<ReturnType<typeof reportOnReportingSiteBandwidthUsage>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnReportingSiteBandwidthUsageParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnReportingSiteBandwidthUsage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnReportingSiteBandwidthUsageSuspenseQueryOptions(
    id,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns how much traffic is cached versus uncached, grouped by content type such as HTML and images.
 * @summary Get cache by content type
 */
export const reportOnSiteCdnCacheContent = (
  id: SiteID,
  params: ReportOnSiteCdnCacheContentParams,
  signal?: AbortSignal
) => {
  return customFetch<CDNCacheContentResponse>({
    url: `/v1/reporting/sites/${id}/cdn/cache-content`,
    method: 'GET',
    params,
    signal,
  });
};

export const getReportOnSiteCdnCacheContentQueryKey = (
  id?: SiteID,
  params?: ReportOnSiteCdnCacheContentParams
) => {
  return [`/v1/reporting/sites/${id}/cdn/cache-content`, ...(params ? [params] : [])] as const;
};

export const getReportOnSiteCdnCacheContentQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteCdnCacheContent>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnCacheContentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteCdnCacheContent>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReportOnSiteCdnCacheContentQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportOnSiteCdnCacheContent>>> = ({
    signal,
  }) => reportOnSiteCdnCacheContent(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/reporting/sites/${id}/cdn/cache-content`,
      operationId: 'app.controllers.reporting_controller.report_on_site_cdn_cache_content',
      operationName: 'reportOnSiteCdnCacheContent',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteCdnCacheContent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteCdnCacheContentQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteCdnCacheContent>>
>;
export type ReportOnSiteCdnCacheContentQueryError = Error;

export function useReportOnSiteCdnCacheContent<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnCacheContent>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnCacheContentParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteCdnCacheContent>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteCdnCacheContent>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteCdnCacheContent>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteCdnCacheContent<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnCacheContent>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnCacheContentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteCdnCacheContent>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteCdnCacheContent>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteCdnCacheContent>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteCdnCacheContent<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnCacheContent>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnCacheContentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteCdnCacheContent>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get cache by content type
 */

export function useReportOnSiteCdnCacheContent<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnCacheContent>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnCacheContentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteCdnCacheContent>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteCdnCacheContentQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getReportOnSiteCdnCacheContentSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteCdnCacheContent>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnCacheContentParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteCdnCacheContent>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReportOnSiteCdnCacheContentQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportOnSiteCdnCacheContent>>> = ({
    signal,
  }) => reportOnSiteCdnCacheContent(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/reporting/sites/${id}/cdn/cache-content`,
      operationId: 'app.controllers.reporting_controller.report_on_site_cdn_cache_content',
      operationName: 'reportOnSiteCdnCacheContent',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteCdnCacheContent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteCdnCacheContentSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteCdnCacheContent>>
>;
export type ReportOnSiteCdnCacheContentSuspenseQueryError = Error;

export function useReportOnSiteCdnCacheContentSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnCacheContent>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnCacheContentParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteCdnCacheContent>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteCdnCacheContentSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnCacheContent>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnCacheContentParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteCdnCacheContent>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteCdnCacheContentSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnCacheContent>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnCacheContentParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteCdnCacheContent>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get cache by content type
 */

export function useReportOnSiteCdnCacheContentSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnCacheContent>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnCacheContentParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteCdnCacheContent>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteCdnCacheContentSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns cache hit, miss, expired, and bypass rates over time.
 * @summary Get cache performance
 */
export const reportOnSiteCdnCacheStatus = (
  id: SiteID,
  params: ReportOnSiteCdnCacheStatusParams,
  signal?: AbortSignal
) => {
  return customFetch<CDNCacheStatusResponse>({
    url: `/v1/reporting/sites/${id}/cdn/cache-status`,
    method: 'GET',
    params,
    signal,
  });
};

export const getReportOnSiteCdnCacheStatusQueryKey = (
  id?: SiteID,
  params?: ReportOnSiteCdnCacheStatusParams
) => {
  return [`/v1/reporting/sites/${id}/cdn/cache-status`, ...(params ? [params] : [])] as const;
};

export const getReportOnSiteCdnCacheStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteCdnCacheStatus>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnCacheStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteCdnCacheStatus>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReportOnSiteCdnCacheStatusQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportOnSiteCdnCacheStatus>>> = ({
    signal,
  }) => reportOnSiteCdnCacheStatus(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/reporting/sites/${id}/cdn/cache-status`,
      operationId: 'app.controllers.reporting_controller.report_on_site_cdn_cache_status',
      operationName: 'reportOnSiteCdnCacheStatus',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteCdnCacheStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteCdnCacheStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteCdnCacheStatus>>
>;
export type ReportOnSiteCdnCacheStatusQueryError = Error;

export function useReportOnSiteCdnCacheStatus<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnCacheStatus>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnCacheStatusParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteCdnCacheStatus>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteCdnCacheStatus>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteCdnCacheStatus>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteCdnCacheStatus<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnCacheStatus>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnCacheStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteCdnCacheStatus>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteCdnCacheStatus>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteCdnCacheStatus>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteCdnCacheStatus<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnCacheStatus>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnCacheStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteCdnCacheStatus>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get cache performance
 */

export function useReportOnSiteCdnCacheStatus<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnCacheStatus>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnCacheStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteCdnCacheStatus>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteCdnCacheStatusQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getReportOnSiteCdnCacheStatusSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteCdnCacheStatus>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnCacheStatusParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteCdnCacheStatus>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReportOnSiteCdnCacheStatusQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportOnSiteCdnCacheStatus>>> = ({
    signal,
  }) => reportOnSiteCdnCacheStatus(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/reporting/sites/${id}/cdn/cache-status`,
      operationId: 'app.controllers.reporting_controller.report_on_site_cdn_cache_status',
      operationName: 'reportOnSiteCdnCacheStatus',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteCdnCacheStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteCdnCacheStatusSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteCdnCacheStatus>>
>;
export type ReportOnSiteCdnCacheStatusSuspenseQueryError = Error;

export function useReportOnSiteCdnCacheStatusSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnCacheStatus>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnCacheStatusParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteCdnCacheStatus>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteCdnCacheStatusSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnCacheStatus>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnCacheStatusParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteCdnCacheStatus>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteCdnCacheStatusSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnCacheStatus>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnCacheStatusParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteCdnCacheStatus>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get cache performance
 */

export function useReportOnSiteCdnCacheStatusSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnCacheStatus>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnCacheStatusParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteCdnCacheStatus>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteCdnCacheStatusSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deprecated. Use GET /sites/{id}/reporting/cdn_request_volume_by_source instead.
 * @summary [Deprecated] Top cached URLs
 */
export const reportOnSiteCdnCacheTopDeprecated = (
  id: SiteID,
  params: ReportOnSiteCdnCacheTopDeprecatedParams,
  signal?: AbortSignal
) => {
  return customFetch<CDNCacheTopResponse>({
    url: `/v1/reporting/sites/${id}/cdn/cache-top`,
    method: 'GET',
    params,
    signal,
  });
};

export const getReportOnSiteCdnCacheTopDeprecatedQueryKey = (
  id?: SiteID,
  params?: ReportOnSiteCdnCacheTopDeprecatedParams
) => {
  return [`/v1/reporting/sites/${id}/cdn/cache-top`, ...(params ? [params] : [])] as const;
};

export const getReportOnSiteCdnCacheTopDeprecatedQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteCdnCacheTopDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnCacheTopDeprecatedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteCdnCacheTopDeprecated>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getReportOnSiteCdnCacheTopDeprecatedQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportOnSiteCdnCacheTopDeprecated>>> = ({
    signal,
  }) => reportOnSiteCdnCacheTopDeprecated(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/reporting/sites/${id}/cdn/cache-top`,
      operationId: 'app.controllers.reporting_controller.report_on_site_cdn_cache_top_deprecated',
      operationName: 'reportOnSiteCdnCacheTopDeprecated',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteCdnCacheTopDeprecated>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteCdnCacheTopDeprecatedQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteCdnCacheTopDeprecated>>
>;
export type ReportOnSiteCdnCacheTopDeprecatedQueryError = Error;

export function useReportOnSiteCdnCacheTopDeprecated<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnCacheTopDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnCacheTopDeprecatedParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteCdnCacheTopDeprecated>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteCdnCacheTopDeprecated>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteCdnCacheTopDeprecated>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteCdnCacheTopDeprecated<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnCacheTopDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnCacheTopDeprecatedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteCdnCacheTopDeprecated>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteCdnCacheTopDeprecated>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteCdnCacheTopDeprecated>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteCdnCacheTopDeprecated<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnCacheTopDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnCacheTopDeprecatedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteCdnCacheTopDeprecated>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary [Deprecated] Top cached URLs
 */

export function useReportOnSiteCdnCacheTopDeprecated<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnCacheTopDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnCacheTopDeprecatedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteCdnCacheTopDeprecated>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteCdnCacheTopDeprecatedQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getReportOnSiteCdnCacheTopDeprecatedSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteCdnCacheTopDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnCacheTopDeprecatedParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteCdnCacheTopDeprecated>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getReportOnSiteCdnCacheTopDeprecatedQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportOnSiteCdnCacheTopDeprecated>>> = ({
    signal,
  }) => reportOnSiteCdnCacheTopDeprecated(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/reporting/sites/${id}/cdn/cache-top`,
      operationId: 'app.controllers.reporting_controller.report_on_site_cdn_cache_top_deprecated',
      operationName: 'reportOnSiteCdnCacheTopDeprecated',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteCdnCacheTopDeprecated>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteCdnCacheTopDeprecatedSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteCdnCacheTopDeprecated>>
>;
export type ReportOnSiteCdnCacheTopDeprecatedSuspenseQueryError = Error;

export function useReportOnSiteCdnCacheTopDeprecatedSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnCacheTopDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnCacheTopDeprecatedParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteCdnCacheTopDeprecated>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteCdnCacheTopDeprecatedSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnCacheTopDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnCacheTopDeprecatedParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteCdnCacheTopDeprecated>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteCdnCacheTopDeprecatedSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnCacheTopDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnCacheTopDeprecatedParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteCdnCacheTopDeprecated>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary [Deprecated] Top cached URLs
 */

export function useReportOnSiteCdnCacheTopDeprecatedSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnCacheTopDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnCacheTopDeprecatedParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteCdnCacheTopDeprecated>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteCdnCacheTopDeprecatedSuspenseQueryOptions(
    id,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns request volume served from the network edge over time. Optionally filter to origin-only requests.
 * @summary Get edge traffic over time
 */
export const reportOnSiteCdnRequests = (
  id: SiteID,
  params: ReportOnSiteCdnRequestsParams,
  signal?: AbortSignal
) => {
  return customFetch<ReportOnSiteCdnRequests200>({
    url: `/v1/reporting/sites/${id}/cdn/requests`,
    method: 'GET',
    params,
    signal,
  });
};

export const getReportOnSiteCdnRequestsQueryKey = (
  id?: SiteID,
  params?: ReportOnSiteCdnRequestsParams
) => {
  return [`/v1/reporting/sites/${id}/cdn/requests`, ...(params ? [params] : [])] as const;
};

export const getReportOnSiteCdnRequestsQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteCdnRequests>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteCdnRequests>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReportOnSiteCdnRequestsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportOnSiteCdnRequests>>> = ({
    signal,
  }) => reportOnSiteCdnRequests(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/reporting/sites/${id}/cdn/requests`,
      operationId: 'app.controllers.reporting_controller.report_on_site_cdn_requests',
      operationName: 'reportOnSiteCdnRequests',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteCdnRequests>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteCdnRequestsQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteCdnRequests>>
>;
export type ReportOnSiteCdnRequestsQueryError = Error;

export function useReportOnSiteCdnRequests<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnRequests>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnRequestsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteCdnRequests>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteCdnRequests>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteCdnRequests>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteCdnRequests<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnRequests>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteCdnRequests>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteCdnRequests>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteCdnRequests>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteCdnRequests<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnRequests>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteCdnRequests>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get edge traffic over time
 */

export function useReportOnSiteCdnRequests<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnRequests>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteCdnRequests>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteCdnRequestsQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getReportOnSiteCdnRequestsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteCdnRequests>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnRequestsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteCdnRequests>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReportOnSiteCdnRequestsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportOnSiteCdnRequests>>> = ({
    signal,
  }) => reportOnSiteCdnRequests(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/reporting/sites/${id}/cdn/requests`,
      operationId: 'app.controllers.reporting_controller.report_on_site_cdn_requests',
      operationName: 'reportOnSiteCdnRequests',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteCdnRequests>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteCdnRequestsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteCdnRequests>>
>;
export type ReportOnSiteCdnRequestsSuspenseQueryError = Error;

export function useReportOnSiteCdnRequestsSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnRequests>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnRequestsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteCdnRequests>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteCdnRequestsSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnRequests>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnRequestsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteCdnRequests>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteCdnRequestsSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnRequests>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnRequestsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteCdnRequests>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get edge traffic over time
 */

export function useReportOnSiteCdnRequestsSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnRequests>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnRequestsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteCdnRequests>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteCdnRequestsSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns unique visitor counts over time for charting and analysis.
 * @summary Get visitor trends
 */
export const reportOnSiteVisitors = (
  id: SiteID,
  params: ReportOnSiteVisitorsParams,
  signal?: AbortSignal
) => {
  return customFetch<CDNVisitorsResponse>({
    url: `/v1/reporting/sites/${id}/visitors`,
    method: 'GET',
    params,
    signal,
  });
};

export const getReportOnSiteVisitorsQueryKey = (
  id?: SiteID,
  params?: ReportOnSiteVisitorsParams
) => {
  return [`/v1/reporting/sites/${id}/visitors`, ...(params ? [params] : [])] as const;
};

export const getReportOnSiteVisitorsQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteVisitors>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteVisitorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteVisitors>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReportOnSiteVisitorsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportOnSiteVisitors>>> = ({ signal }) =>
    reportOnSiteVisitors(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/reporting/sites/${id}/visitors`,
      operationId: 'app.controllers.reporting_controller.report_on_site_visitors',
      operationName: 'reportOnSiteVisitors',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteVisitors>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteVisitorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteVisitors>>
>;
export type ReportOnSiteVisitorsQueryError = Error;

export function useReportOnSiteVisitors<
  TData = Awaited<ReturnType<typeof reportOnSiteVisitors>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteVisitorsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteVisitors>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteVisitors>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteVisitors>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteVisitors<
  TData = Awaited<ReturnType<typeof reportOnSiteVisitors>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteVisitorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteVisitors>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteVisitors>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteVisitors>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteVisitors<
  TData = Awaited<ReturnType<typeof reportOnSiteVisitors>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteVisitorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteVisitors>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get visitor trends
 */

export function useReportOnSiteVisitors<
  TData = Awaited<ReturnType<typeof reportOnSiteVisitors>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteVisitorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteVisitors>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteVisitorsQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getReportOnSiteVisitorsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteVisitors>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteVisitorsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteVisitors>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReportOnSiteVisitorsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportOnSiteVisitors>>> = ({ signal }) =>
    reportOnSiteVisitors(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/reporting/sites/${id}/visitors`,
      operationId: 'app.controllers.reporting_controller.report_on_site_visitors',
      operationName: 'reportOnSiteVisitors',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteVisitors>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteVisitorsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteVisitors>>
>;
export type ReportOnSiteVisitorsSuspenseQueryError = Error;

export function useReportOnSiteVisitorsSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteVisitors>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteVisitorsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteVisitors>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteVisitorsSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteVisitors>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteVisitorsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteVisitors>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteVisitorsSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteVisitors>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteVisitorsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteVisitors>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get visitor trends
 */

export function useReportOnSiteVisitorsSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteVisitors>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteVisitorsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteVisitors>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteVisitorsSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a paginated list of requests that triggered firewall actions. Filter by IP, path, country, action, and more.
 * @summary List firewall events
 */
export const reportOnSiteWafEventlist = (
  id: SiteID,
  params: ReportOnSiteWafEventlistParams,
  signal?: AbortSignal
) => {
  return customFetch<ListWAFEventsResponse>({
    url: `/v1/reporting/sites/${id}/waf/eventlist`,
    method: 'GET',
    params,
    signal,
  });
};

export const getReportOnSiteWafEventlistQueryKey = (
  id?: SiteID,
  params?: ReportOnSiteWafEventlistParams
) => {
  return [`/v1/reporting/sites/${id}/waf/eventlist`, ...(params ? [params] : [])] as const;
};

export const getReportOnSiteWafEventlistQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventlist>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventlistParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventlist>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReportOnSiteWafEventlistQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportOnSiteWafEventlist>>> = ({
    signal,
  }) => reportOnSiteWafEventlist(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/reporting/sites/${id}/waf/eventlist`,
      operationId: 'app.controllers.reporting_controller.report_on_site_waf_eventlist',
      operationName: 'reportOnSiteWafEventlist',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteWafEventlist>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteWafEventlistQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteWafEventlist>>
>;
export type ReportOnSiteWafEventlistQueryError = Error;

export function useReportOnSiteWafEventlist<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventlist>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventlistParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventlist>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteWafEventlist>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteWafEventlist>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteWafEventlist<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventlist>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventlistParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventlist>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteWafEventlist>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteWafEventlist>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteWafEventlist<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventlist>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventlistParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventlist>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List firewall events
 */

export function useReportOnSiteWafEventlist<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventlist>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventlistParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventlist>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteWafEventlistQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getReportOnSiteWafEventlistSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventlist>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventlistParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventlist>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReportOnSiteWafEventlistQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportOnSiteWafEventlist>>> = ({
    signal,
  }) => reportOnSiteWafEventlist(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/reporting/sites/${id}/waf/eventlist`,
      operationId: 'app.controllers.reporting_controller.report_on_site_waf_eventlist',
      operationName: 'reportOnSiteWafEventlist',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteWafEventlist>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteWafEventlistSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteWafEventlist>>
>;
export type ReportOnSiteWafEventlistSuspenseQueryError = Error;

export function useReportOnSiteWafEventlistSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventlist>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventlistParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventlist>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteWafEventlistSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventlist>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventlistParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventlist>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteWafEventlistSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventlist>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventlistParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventlist>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List firewall events
 */

export function useReportOnSiteWafEventlistSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventlist>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventlistParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventlist>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteWafEventlistSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deprecated. Use GET /reporting/sites/{id}/waf/eventlist instead.
 * @summary [Deprecated] List firewall events
 */
export const reportOnSiteWafEventsDeprecated = (
  id: SiteID,
  params: ReportOnSiteWafEventsDeprecatedParams,
  signal?: AbortSignal
) => {
  return customFetch<WAFEventsResponse>({
    url: `/v1/reporting/sites/${id}/waf/events`,
    method: 'GET',
    params,
    signal,
  });
};

export const getReportOnSiteWafEventsDeprecatedQueryKey = (
  id?: SiteID,
  params?: ReportOnSiteWafEventsDeprecatedParams
) => {
  return [`/v1/reporting/sites/${id}/waf/events`, ...(params ? [params] : [])] as const;
};

export const getReportOnSiteWafEventsDeprecatedQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsDeprecatedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventsDeprecated>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReportOnSiteWafEventsDeprecatedQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportOnSiteWafEventsDeprecated>>> = ({
    signal,
  }) => reportOnSiteWafEventsDeprecated(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/reporting/sites/${id}/waf/events`,
      operationId: 'app.controllers.reporting_controller.report_on_site_waf_events_deprecated',
      operationName: 'reportOnSiteWafEventsDeprecated',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteWafEventsDeprecated>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteWafEventsDeprecatedQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteWafEventsDeprecated>>
>;
export type ReportOnSiteWafEventsDeprecatedQueryError = Error;

export function useReportOnSiteWafEventsDeprecated<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsDeprecatedParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventsDeprecated>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteWafEventsDeprecated>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteWafEventsDeprecated>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteWafEventsDeprecated<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsDeprecatedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventsDeprecated>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteWafEventsDeprecated>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteWafEventsDeprecated>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteWafEventsDeprecated<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsDeprecatedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventsDeprecated>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary [Deprecated] List firewall events
 */

export function useReportOnSiteWafEventsDeprecated<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsDeprecatedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventsDeprecated>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteWafEventsDeprecatedQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getReportOnSiteWafEventsDeprecatedSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsDeprecatedParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteWafEventsDeprecated>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReportOnSiteWafEventsDeprecatedQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportOnSiteWafEventsDeprecated>>> = ({
    signal,
  }) => reportOnSiteWafEventsDeprecated(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/reporting/sites/${id}/waf/events`,
      operationId: 'app.controllers.reporting_controller.report_on_site_waf_events_deprecated',
      operationName: 'reportOnSiteWafEventsDeprecated',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteWafEventsDeprecated>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteWafEventsDeprecatedSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteWafEventsDeprecated>>
>;
export type ReportOnSiteWafEventsDeprecatedSuspenseQueryError = Error;

export function useReportOnSiteWafEventsDeprecatedSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsDeprecatedParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteWafEventsDeprecated>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteWafEventsDeprecatedSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsDeprecatedParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteWafEventsDeprecated>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteWafEventsDeprecatedSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsDeprecatedParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteWafEventsDeprecated>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary [Deprecated] List firewall events
 */

export function useReportOnSiteWafEventsDeprecatedSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsDeprecatedParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteWafEventsDeprecated>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteWafEventsDeprecatedSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deprecated. Use GET /reporting/sites/{id}/waf/events-stats instead.
 * @deprecated
 * @summary [Deprecated] Events by service
 */
export const reportOnSiteWafEventsServicesDeprecated = (
  id: SiteID,
  params: ReportOnSiteWafEventsServicesDeprecatedParams,
  signal?: AbortSignal
) => {
  return customFetch<WAFEventsServicesResponse>({
    url: `/v1/reporting/sites/${id}/waf/events-services`,
    method: 'GET',
    params,
    signal,
  });
};

export const getReportOnSiteWafEventsServicesDeprecatedQueryKey = (
  id?: SiteID,
  params?: ReportOnSiteWafEventsServicesDeprecatedParams
) => {
  return [`/v1/reporting/sites/${id}/waf/events-services`, ...(params ? [params] : [])] as const;
};

export const getReportOnSiteWafEventsServicesDeprecatedQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsServicesDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsServicesDeprecatedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteWafEventsServicesDeprecated>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getReportOnSiteWafEventsServicesDeprecatedQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof reportOnSiteWafEventsServicesDeprecated>>
  > = ({ signal }) => reportOnSiteWafEventsServicesDeprecated(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/reporting/sites/${id}/waf/events-services`,
      operationId:
        'app.controllers.reporting_controller.report_on_site_waf_events_services_deprecated',
      operationName: 'reportOnSiteWafEventsServicesDeprecated',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteWafEventsServicesDeprecated>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteWafEventsServicesDeprecatedQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteWafEventsServicesDeprecated>>
>;
export type ReportOnSiteWafEventsServicesDeprecatedQueryError = Error;

export function useReportOnSiteWafEventsServicesDeprecated<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsServicesDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsServicesDeprecatedParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteWafEventsServicesDeprecated>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteWafEventsServicesDeprecated>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteWafEventsServicesDeprecated>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteWafEventsServicesDeprecated<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsServicesDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsServicesDeprecatedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteWafEventsServicesDeprecated>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteWafEventsServicesDeprecated>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteWafEventsServicesDeprecated>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteWafEventsServicesDeprecated<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsServicesDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsServicesDeprecatedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteWafEventsServicesDeprecated>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @deprecated
 * @summary [Deprecated] Events by service
 */

export function useReportOnSiteWafEventsServicesDeprecated<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsServicesDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsServicesDeprecatedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteWafEventsServicesDeprecated>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteWafEventsServicesDeprecatedQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getReportOnSiteWafEventsServicesDeprecatedSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsServicesDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsServicesDeprecatedParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteWafEventsServicesDeprecated>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getReportOnSiteWafEventsServicesDeprecatedQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof reportOnSiteWafEventsServicesDeprecated>>
  > = ({ signal }) => reportOnSiteWafEventsServicesDeprecated(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/reporting/sites/${id}/waf/events-services`,
      operationId:
        'app.controllers.reporting_controller.report_on_site_waf_events_services_deprecated',
      operationName: 'reportOnSiteWafEventsServicesDeprecated',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteWafEventsServicesDeprecated>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteWafEventsServicesDeprecatedSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteWafEventsServicesDeprecated>>
>;
export type ReportOnSiteWafEventsServicesDeprecatedSuspenseQueryError = Error;

export function useReportOnSiteWafEventsServicesDeprecatedSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsServicesDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsServicesDeprecatedParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteWafEventsServicesDeprecated>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteWafEventsServicesDeprecatedSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsServicesDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsServicesDeprecatedParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteWafEventsServicesDeprecated>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteWafEventsServicesDeprecatedSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsServicesDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsServicesDeprecatedParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteWafEventsServicesDeprecated>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @deprecated
 * @summary [Deprecated] Events by service
 */

export function useReportOnSiteWafEventsServicesDeprecatedSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsServicesDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsServicesDeprecatedParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteWafEventsServicesDeprecated>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteWafEventsServicesDeprecatedSuspenseQueryOptions(
    id,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the most common origins of firewall events: IPs, URLs, countries, and similar groupings.
 * @summary Get top security event sources
 */
export const reportOnSiteWafEventsSource = (
  id: SiteID,
  params: ReportOnSiteWafEventsSourceParams,
  signal?: AbortSignal
) => {
  return customFetch<WAFFirewallEventsSourceResponse>({
    url: `/v1/reporting/sites/${id}/waf/events-source`,
    method: 'GET',
    params,
    signal,
  });
};

export const getReportOnSiteWafEventsSourceQueryKey = (
  id?: SiteID,
  params?: ReportOnSiteWafEventsSourceParams
) => {
  return [`/v1/reporting/sites/${id}/waf/events-source`, ...(params ? [params] : [])] as const;
};

export const getReportOnSiteWafEventsSourceQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsSource>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsSourceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventsSource>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReportOnSiteWafEventsSourceQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportOnSiteWafEventsSource>>> = ({
    signal,
  }) => reportOnSiteWafEventsSource(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/reporting/sites/${id}/waf/events-source`,
      operationId: 'app.controllers.reporting_controller.report_on_site_waf_events_source',
      operationName: 'reportOnSiteWafEventsSource',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteWafEventsSource>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteWafEventsSourceQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteWafEventsSource>>
>;
export type ReportOnSiteWafEventsSourceQueryError = Error;

export function useReportOnSiteWafEventsSource<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsSource>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsSourceParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventsSource>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteWafEventsSource>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteWafEventsSource>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteWafEventsSource<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsSource>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsSourceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventsSource>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteWafEventsSource>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteWafEventsSource>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteWafEventsSource<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsSource>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsSourceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventsSource>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get top security event sources
 */

export function useReportOnSiteWafEventsSource<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsSource>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsSourceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventsSource>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteWafEventsSourceQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getReportOnSiteWafEventsSourceSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsSource>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsSourceParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteWafEventsSource>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReportOnSiteWafEventsSourceQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportOnSiteWafEventsSource>>> = ({
    signal,
  }) => reportOnSiteWafEventsSource(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/reporting/sites/${id}/waf/events-source`,
      operationId: 'app.controllers.reporting_controller.report_on_site_waf_events_source',
      operationName: 'reportOnSiteWafEventsSource',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteWafEventsSource>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteWafEventsSourceSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteWafEventsSource>>
>;
export type ReportOnSiteWafEventsSourceSuspenseQueryError = Error;

export function useReportOnSiteWafEventsSourceSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsSource>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsSourceParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteWafEventsSource>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteWafEventsSourceSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsSource>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsSourceParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteWafEventsSource>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteWafEventsSourceSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsSource>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsSourceParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteWafEventsSource>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get top security event sources
 */

export function useReportOnSiteWafEventsSourceSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsSource>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsSourceParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteWafEventsSource>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteWafEventsSourceSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns firewall events over time plus totals by protection layer, source, and action such as block, challenge, or allow.
 * @summary Get security event summary
 */
export const reportOnSiteWafEventsStats = (
  id: SiteID,
  params: ReportOnSiteWafEventsStatsParams,
  signal?: AbortSignal
) => {
  return customFetch<WAFEventsStatsResponse>({
    url: `/v1/reporting/sites/${id}/waf/events-stats`,
    method: 'GET',
    params,
    signal,
  });
};

export const getReportOnSiteWafEventsStatsQueryKey = (
  id?: SiteID,
  params?: ReportOnSiteWafEventsStatsParams
) => {
  return [`/v1/reporting/sites/${id}/waf/events-stats`, ...(params ? [params] : [])] as const;
};

export const getReportOnSiteWafEventsStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsStats>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventsStats>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReportOnSiteWafEventsStatsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportOnSiteWafEventsStats>>> = ({
    signal,
  }) => reportOnSiteWafEventsStats(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/reporting/sites/${id}/waf/events-stats`,
      operationId: 'app.controllers.reporting_controller.report_on_site_waf_events_stats',
      operationName: 'reportOnSiteWafEventsStats',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteWafEventsStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteWafEventsStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteWafEventsStats>>
>;
export type ReportOnSiteWafEventsStatsQueryError = Error;

export function useReportOnSiteWafEventsStats<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsStats>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsStatsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventsStats>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteWafEventsStats>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteWafEventsStats>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteWafEventsStats<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsStats>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventsStats>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteWafEventsStats>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteWafEventsStats>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteWafEventsStats<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsStats>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventsStats>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get security event summary
 */

export function useReportOnSiteWafEventsStats<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsStats>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventsStats>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteWafEventsStatsQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getReportOnSiteWafEventsStatsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsStats>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventsStats>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReportOnSiteWafEventsStatsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportOnSiteWafEventsStats>>> = ({
    signal,
  }) => reportOnSiteWafEventsStats(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/reporting/sites/${id}/waf/events-stats`,
      operationId: 'app.controllers.reporting_controller.report_on_site_waf_events_stats',
      operationName: 'reportOnSiteWafEventsStats',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteWafEventsStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteWafEventsStatsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteWafEventsStats>>
>;
export type ReportOnSiteWafEventsStatsSuspenseQueryError = Error;

export function useReportOnSiteWafEventsStatsSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsStats>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsStatsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventsStats>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteWafEventsStatsSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsStats>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventsStats>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteWafEventsStatsSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsStats>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventsStats>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get security event summary
 */

export function useReportOnSiteWafEventsStatsSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsStats>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventsStats>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteWafEventsStatsSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns firewall event counts over time for trend charts.
 * @summary Get security events over time
 */
export const reportOnSiteWafEventsTime = (
  id: SiteID,
  params: ReportOnSiteWafEventsTimeParams,
  signal?: AbortSignal
) => {
  return customFetch<WAFEventsTimeResponse>({
    url: `/v1/reporting/sites/${id}/waf/events-time`,
    method: 'GET',
    params,
    signal,
  });
};

export const getReportOnSiteWafEventsTimeQueryKey = (
  id?: SiteID,
  params?: ReportOnSiteWafEventsTimeParams
) => {
  return [`/v1/reporting/sites/${id}/waf/events-time`, ...(params ? [params] : [])] as const;
};

export const getReportOnSiteWafEventsTimeQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsTime>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsTimeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventsTime>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReportOnSiteWafEventsTimeQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportOnSiteWafEventsTime>>> = ({
    signal,
  }) => reportOnSiteWafEventsTime(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/reporting/sites/${id}/waf/events-time`,
      operationId: 'app.controllers.reporting_controller.report_on_site_waf_events_time',
      operationName: 'reportOnSiteWafEventsTime',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteWafEventsTime>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteWafEventsTimeQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteWafEventsTime>>
>;
export type ReportOnSiteWafEventsTimeQueryError = Error;

export function useReportOnSiteWafEventsTime<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsTime>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsTimeParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventsTime>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteWafEventsTime>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteWafEventsTime>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteWafEventsTime<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsTime>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsTimeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventsTime>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteWafEventsTime>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteWafEventsTime>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteWafEventsTime<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsTime>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsTimeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventsTime>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get security events over time
 */

export function useReportOnSiteWafEventsTime<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsTime>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsTimeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventsTime>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteWafEventsTimeQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getReportOnSiteWafEventsTimeSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsTime>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsTimeParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventsTime>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReportOnSiteWafEventsTimeQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportOnSiteWafEventsTime>>> = ({
    signal,
  }) => reportOnSiteWafEventsTime(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/reporting/sites/${id}/waf/events-time`,
      operationId: 'app.controllers.reporting_controller.report_on_site_waf_events_time',
      operationName: 'reportOnSiteWafEventsTime',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteWafEventsTime>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteWafEventsTimeSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteWafEventsTime>>
>;
export type ReportOnSiteWafEventsTimeSuspenseQueryError = Error;

export function useReportOnSiteWafEventsTimeSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsTime>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsTimeParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventsTime>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteWafEventsTimeSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsTime>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsTimeParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventsTime>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteWafEventsTimeSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsTime>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsTimeParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventsTime>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get security events over time
 */

export function useReportOnSiteWafEventsTimeSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteWafEventsTime>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafEventsTimeParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteWafEventsTime>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteWafEventsTimeSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deprecated. Use GET /reporting/sites/{id}/waf/events-stats instead.
 * @deprecated
 * @summary [Deprecated] Firewall event totals
 */
export const reportOnSiteWafFirewallEventsDeprecated = (
  id: SiteID,
  params: ReportOnSiteWafFirewallEventsDeprecatedParams,
  signal?: AbortSignal
) => {
  return customFetch<WAFFirewallEventsResponse>({
    url: `/v1/reporting/sites/${id}/waf/firewall-events`,
    method: 'GET',
    params,
    signal,
  });
};

export const getReportOnSiteWafFirewallEventsDeprecatedQueryKey = (
  id?: SiteID,
  params?: ReportOnSiteWafFirewallEventsDeprecatedParams
) => {
  return [`/v1/reporting/sites/${id}/waf/firewall-events`, ...(params ? [params] : [])] as const;
};

export const getReportOnSiteWafFirewallEventsDeprecatedQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteWafFirewallEventsDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafFirewallEventsDeprecatedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteWafFirewallEventsDeprecated>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getReportOnSiteWafFirewallEventsDeprecatedQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof reportOnSiteWafFirewallEventsDeprecated>>
  > = ({ signal }) => reportOnSiteWafFirewallEventsDeprecated(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/reporting/sites/${id}/waf/firewall-events`,
      operationId:
        'app.controllers.reporting_controller.report_on_site_waf_firewall_events_deprecated',
      operationName: 'reportOnSiteWafFirewallEventsDeprecated',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteWafFirewallEventsDeprecated>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteWafFirewallEventsDeprecatedQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteWafFirewallEventsDeprecated>>
>;
export type ReportOnSiteWafFirewallEventsDeprecatedQueryError = Error;

export function useReportOnSiteWafFirewallEventsDeprecated<
  TData = Awaited<ReturnType<typeof reportOnSiteWafFirewallEventsDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafFirewallEventsDeprecatedParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteWafFirewallEventsDeprecated>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteWafFirewallEventsDeprecated>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteWafFirewallEventsDeprecated>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteWafFirewallEventsDeprecated<
  TData = Awaited<ReturnType<typeof reportOnSiteWafFirewallEventsDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafFirewallEventsDeprecatedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteWafFirewallEventsDeprecated>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteWafFirewallEventsDeprecated>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteWafFirewallEventsDeprecated>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteWafFirewallEventsDeprecated<
  TData = Awaited<ReturnType<typeof reportOnSiteWafFirewallEventsDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafFirewallEventsDeprecatedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteWafFirewallEventsDeprecated>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @deprecated
 * @summary [Deprecated] Firewall event totals
 */

export function useReportOnSiteWafFirewallEventsDeprecated<
  TData = Awaited<ReturnType<typeof reportOnSiteWafFirewallEventsDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafFirewallEventsDeprecatedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteWafFirewallEventsDeprecated>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteWafFirewallEventsDeprecatedQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getReportOnSiteWafFirewallEventsDeprecatedSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteWafFirewallEventsDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafFirewallEventsDeprecatedParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteWafFirewallEventsDeprecated>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getReportOnSiteWafFirewallEventsDeprecatedQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof reportOnSiteWafFirewallEventsDeprecated>>
  > = ({ signal }) => reportOnSiteWafFirewallEventsDeprecated(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/reporting/sites/${id}/waf/firewall-events`,
      operationId:
        'app.controllers.reporting_controller.report_on_site_waf_firewall_events_deprecated',
      operationName: 'reportOnSiteWafFirewallEventsDeprecated',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteWafFirewallEventsDeprecated>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteWafFirewallEventsDeprecatedSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteWafFirewallEventsDeprecated>>
>;
export type ReportOnSiteWafFirewallEventsDeprecatedSuspenseQueryError = Error;

export function useReportOnSiteWafFirewallEventsDeprecatedSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteWafFirewallEventsDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafFirewallEventsDeprecatedParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteWafFirewallEventsDeprecated>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteWafFirewallEventsDeprecatedSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteWafFirewallEventsDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafFirewallEventsDeprecatedParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteWafFirewallEventsDeprecated>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteWafFirewallEventsDeprecatedSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteWafFirewallEventsDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafFirewallEventsDeprecatedParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteWafFirewallEventsDeprecated>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @deprecated
 * @summary [Deprecated] Firewall event totals
 */

export function useReportOnSiteWafFirewallEventsDeprecatedSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteWafFirewallEventsDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteWafFirewallEventsDeprecatedParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteWafFirewallEventsDeprecated>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteWafFirewallEventsDeprecatedSuspenseQueryOptions(
    id,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deprecated. Use GET /sites/{id}/access_logs instead.
 * @summary [Deprecated] Search access logs
 */
export const listSiteAccessLogsAliasDeprecated = (
  id: SiteID,
  params: ListSiteAccessLogsAliasDeprecatedParams,
  signal?: AbortSignal
) => {
  return customFetch<ListAccessLogsResponse>({
    url: `/v1/sites/${id}/access-logs`,
    method: 'GET',
    params,
    signal,
  });
};

export const getListSiteAccessLogsAliasDeprecatedQueryKey = (
  id?: SiteID,
  params?: ListSiteAccessLogsAliasDeprecatedParams
) => {
  return [`/v1/sites/${id}/access-logs`, ...(params ? [params] : [])] as const;
};

export const getListSiteAccessLogsAliasDeprecatedQueryOptions = <
  TData = Awaited<ReturnType<typeof listSiteAccessLogsAliasDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ListSiteAccessLogsAliasDeprecatedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteAccessLogsAliasDeprecated>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListSiteAccessLogsAliasDeprecatedQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSiteAccessLogsAliasDeprecated>>> = ({
    signal,
  }) => listSiteAccessLogsAliasDeprecated(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/access-logs`,
      operationId: 'app.controllers.access_logs_controller.list_site_access_logs_alias_deprecated',
      operationName: 'listSiteAccessLogsAliasDeprecated',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof listSiteAccessLogsAliasDeprecated>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSiteAccessLogsAliasDeprecatedQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSiteAccessLogsAliasDeprecated>>
>;
export type ListSiteAccessLogsAliasDeprecatedQueryError = Error;

export function useListSiteAccessLogsAliasDeprecated<
  TData = Awaited<ReturnType<typeof listSiteAccessLogsAliasDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ListSiteAccessLogsAliasDeprecatedParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteAccessLogsAliasDeprecated>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSiteAccessLogsAliasDeprecated>>,
          TError,
          Awaited<ReturnType<typeof listSiteAccessLogsAliasDeprecated>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteAccessLogsAliasDeprecated<
  TData = Awaited<ReturnType<typeof listSiteAccessLogsAliasDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ListSiteAccessLogsAliasDeprecatedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteAccessLogsAliasDeprecated>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSiteAccessLogsAliasDeprecated>>,
          TError,
          Awaited<ReturnType<typeof listSiteAccessLogsAliasDeprecated>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteAccessLogsAliasDeprecated<
  TData = Awaited<ReturnType<typeof listSiteAccessLogsAliasDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ListSiteAccessLogsAliasDeprecatedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteAccessLogsAliasDeprecated>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary [Deprecated] Search access logs
 */

export function useListSiteAccessLogsAliasDeprecated<
  TData = Awaited<ReturnType<typeof listSiteAccessLogsAliasDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ListSiteAccessLogsAliasDeprecatedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteAccessLogsAliasDeprecated>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSiteAccessLogsAliasDeprecatedQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListSiteAccessLogsAliasDeprecatedSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listSiteAccessLogsAliasDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ListSiteAccessLogsAliasDeprecatedParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof listSiteAccessLogsAliasDeprecated>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListSiteAccessLogsAliasDeprecatedQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSiteAccessLogsAliasDeprecated>>> = ({
    signal,
  }) => listSiteAccessLogsAliasDeprecated(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/access-logs`,
      operationId: 'app.controllers.access_logs_controller.list_site_access_logs_alias_deprecated',
      operationName: 'listSiteAccessLogsAliasDeprecated',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listSiteAccessLogsAliasDeprecated>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSiteAccessLogsAliasDeprecatedSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSiteAccessLogsAliasDeprecated>>
>;
export type ListSiteAccessLogsAliasDeprecatedSuspenseQueryError = Error;

export function useListSiteAccessLogsAliasDeprecatedSuspense<
  TData = Awaited<ReturnType<typeof listSiteAccessLogsAliasDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ListSiteAccessLogsAliasDeprecatedParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof listSiteAccessLogsAliasDeprecated>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteAccessLogsAliasDeprecatedSuspense<
  TData = Awaited<ReturnType<typeof listSiteAccessLogsAliasDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ListSiteAccessLogsAliasDeprecatedParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof listSiteAccessLogsAliasDeprecated>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteAccessLogsAliasDeprecatedSuspense<
  TData = Awaited<ReturnType<typeof listSiteAccessLogsAliasDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ListSiteAccessLogsAliasDeprecatedParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof listSiteAccessLogsAliasDeprecated>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary [Deprecated] Search access logs
 */

export function useListSiteAccessLogsAliasDeprecatedSuspense<
  TData = Awaited<ReturnType<typeof listSiteAccessLogsAliasDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: ListSiteAccessLogsAliasDeprecatedParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof listSiteAccessLogsAliasDeprecated>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSiteAccessLogsAliasDeprecatedSuspenseQueryOptions(
    id,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns paginated HTTP access logs. Filter by IP, URI, status code, cache status, device type, and date range.
 * @summary Search site access logs
 */
export const listSiteAccessLogs = (
  id: SiteID,
  params: ListSiteAccessLogsParams,
  signal?: AbortSignal
) => {
  return customFetch<ListAccessLogsResponse>({
    url: `/v1/sites/${id}/access_logs`,
    method: 'GET',
    params,
    signal,
  });
};

export const getListSiteAccessLogsQueryKey = (id?: SiteID, params?: ListSiteAccessLogsParams) => {
  return [`/v1/sites/${id}/access_logs`, ...(params ? [params] : [])] as const;
};

export const getListSiteAccessLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSiteAccessLogs>>,
  TError = Error,
>(
  id: SiteID,
  params: ListSiteAccessLogsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSiteAccessLogs>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSiteAccessLogsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSiteAccessLogs>>> = ({ signal }) =>
    listSiteAccessLogs(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/access_logs`,
      operationId: 'app.controllers.access_logs_controller.list_site_access_logs',
      operationName: 'listSiteAccessLogs',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof listSiteAccessLogs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSiteAccessLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSiteAccessLogs>>
>;
export type ListSiteAccessLogsQueryError = Error;

export function useListSiteAccessLogs<
  TData = Awaited<ReturnType<typeof listSiteAccessLogs>>,
  TError = Error,
>(
  id: SiteID,
  params: ListSiteAccessLogsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSiteAccessLogs>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSiteAccessLogs>>,
          TError,
          Awaited<ReturnType<typeof listSiteAccessLogs>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteAccessLogs<
  TData = Awaited<ReturnType<typeof listSiteAccessLogs>>,
  TError = Error,
>(
  id: SiteID,
  params: ListSiteAccessLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteAccessLogs>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSiteAccessLogs>>,
          TError,
          Awaited<ReturnType<typeof listSiteAccessLogs>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteAccessLogs<
  TData = Awaited<ReturnType<typeof listSiteAccessLogs>>,
  TError = Error,
>(
  id: SiteID,
  params: ListSiteAccessLogsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSiteAccessLogs>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Search site access logs
 */

export function useListSiteAccessLogs<
  TData = Awaited<ReturnType<typeof listSiteAccessLogs>>,
  TError = Error,
>(
  id: SiteID,
  params: ListSiteAccessLogsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSiteAccessLogs>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSiteAccessLogsQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListSiteAccessLogsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listSiteAccessLogs>>,
  TError = Error,
>(
  id: SiteID,
  params: ListSiteAccessLogsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteAccessLogs>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSiteAccessLogsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSiteAccessLogs>>> = ({ signal }) =>
    listSiteAccessLogs(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/access_logs`,
      operationId: 'app.controllers.access_logs_controller.list_site_access_logs',
      operationName: 'listSiteAccessLogs',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listSiteAccessLogs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSiteAccessLogsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSiteAccessLogs>>
>;
export type ListSiteAccessLogsSuspenseQueryError = Error;

export function useListSiteAccessLogsSuspense<
  TData = Awaited<ReturnType<typeof listSiteAccessLogs>>,
  TError = Error,
>(
  id: SiteID,
  params: ListSiteAccessLogsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteAccessLogs>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteAccessLogsSuspense<
  TData = Awaited<ReturnType<typeof listSiteAccessLogs>>,
  TError = Error,
>(
  id: SiteID,
  params: ListSiteAccessLogsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteAccessLogs>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteAccessLogsSuspense<
  TData = Awaited<ReturnType<typeof listSiteAccessLogs>>,
  TError = Error,
>(
  id: SiteID,
  params: ListSiteAccessLogsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteAccessLogs>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Search site access logs
 */

export function useListSiteAccessLogsSuspense<
  TData = Awaited<ReturnType<typeof listSiteAccessLogs>>,
  TError = Error,
>(
  id: SiteID,
  params: ListSiteAccessLogsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteAccessLogs>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSiteAccessLogsSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a breakdown of request volume by source characteristics such as cached versus dynamic traffic.
 * @summary Get traffic by request type
 */
export const reportOnSiteCdnRequestVolumeBySource = (
  id: SiteID,
  params: ReportOnSiteCdnRequestVolumeBySourceParams,
  signal?: AbortSignal
) => {
  return customFetch<CDNRequestVolumeBySourceResponse>({
    url: `/v1/sites/${id}/reporting/cdn_request_volume_by_source`,
    method: 'GET',
    params,
    signal,
  });
};

export const getReportOnSiteCdnRequestVolumeBySourceQueryKey = (
  id?: SiteID,
  params?: ReportOnSiteCdnRequestVolumeBySourceParams
) => {
  return [
    `/v1/sites/${id}/reporting/cdn_request_volume_by_source`,
    ...(params ? [params] : []),
  ] as const;
};

export const getReportOnSiteCdnRequestVolumeBySourceQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteCdnRequestVolumeBySource>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnRequestVolumeBySourceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteCdnRequestVolumeBySource>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getReportOnSiteCdnRequestVolumeBySourceQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof reportOnSiteCdnRequestVolumeBySource>>
  > = ({ signal }) => reportOnSiteCdnRequestVolumeBySource(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/reporting/cdn_request_volume_by_source`,
      operationId:
        'app.controllers.reporting_controller.report_on_site_cdn_request_volume_by_source',
      operationName: 'reportOnSiteCdnRequestVolumeBySource',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteCdnRequestVolumeBySource>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteCdnRequestVolumeBySourceQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteCdnRequestVolumeBySource>>
>;
export type ReportOnSiteCdnRequestVolumeBySourceQueryError = Error;

export function useReportOnSiteCdnRequestVolumeBySource<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnRequestVolumeBySource>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnRequestVolumeBySourceParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteCdnRequestVolumeBySource>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteCdnRequestVolumeBySource>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteCdnRequestVolumeBySource>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteCdnRequestVolumeBySource<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnRequestVolumeBySource>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnRequestVolumeBySourceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteCdnRequestVolumeBySource>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteCdnRequestVolumeBySource>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteCdnRequestVolumeBySource>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteCdnRequestVolumeBySource<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnRequestVolumeBySource>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnRequestVolumeBySourceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteCdnRequestVolumeBySource>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get traffic by request type
 */

export function useReportOnSiteCdnRequestVolumeBySource<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnRequestVolumeBySource>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnRequestVolumeBySourceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteCdnRequestVolumeBySource>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteCdnRequestVolumeBySourceQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getReportOnSiteCdnRequestVolumeBySourceSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteCdnRequestVolumeBySource>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnRequestVolumeBySourceParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteCdnRequestVolumeBySource>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getReportOnSiteCdnRequestVolumeBySourceQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof reportOnSiteCdnRequestVolumeBySource>>
  > = ({ signal }) => reportOnSiteCdnRequestVolumeBySource(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/reporting/cdn_request_volume_by_source`,
      operationId:
        'app.controllers.reporting_controller.report_on_site_cdn_request_volume_by_source',
      operationName: 'reportOnSiteCdnRequestVolumeBySource',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteCdnRequestVolumeBySource>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteCdnRequestVolumeBySourceSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteCdnRequestVolumeBySource>>
>;
export type ReportOnSiteCdnRequestVolumeBySourceSuspenseQueryError = Error;

export function useReportOnSiteCdnRequestVolumeBySourceSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnRequestVolumeBySource>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnRequestVolumeBySourceParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteCdnRequestVolumeBySource>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteCdnRequestVolumeBySourceSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnRequestVolumeBySource>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnRequestVolumeBySourceParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteCdnRequestVolumeBySource>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteCdnRequestVolumeBySourceSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnRequestVolumeBySource>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnRequestVolumeBySourceParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteCdnRequestVolumeBySource>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get traffic by request type
 */

export function useReportOnSiteCdnRequestVolumeBySourceSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteCdnRequestVolumeBySource>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteCdnRequestVolumeBySourceParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportOnSiteCdnRequestVolumeBySource>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteCdnRequestVolumeBySourceSuspenseQueryOptions(
    id,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns all inbound request sources to the site for a time period.
 * @summary Get total request sources
 */
export const reportOnSiteTotalRequests = (
  id: SiteID,
  params: ReportOnSiteTotalRequestsParams,
  signal?: AbortSignal
) => {
  return customFetch<TotalRequestsResponse>({
    url: `/v1/sites/${id}/reporting/total_requests`,
    method: 'GET',
    params,
    signal,
  });
};

export const getReportOnSiteTotalRequestsQueryKey = (
  id?: SiteID,
  params?: ReportOnSiteTotalRequestsParams
) => {
  return [`/v1/sites/${id}/reporting/total_requests`, ...(params ? [params] : [])] as const;
};

export const getReportOnSiteTotalRequestsQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteTotalRequests>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteTotalRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteTotalRequests>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReportOnSiteTotalRequestsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportOnSiteTotalRequests>>> = ({
    signal,
  }) => reportOnSiteTotalRequests(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/reporting/total_requests`,
      operationId: 'app.controllers.reporting_controller.report_on_site_total_requests',
      operationName: 'reportOnSiteTotalRequests',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteTotalRequests>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteTotalRequestsQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteTotalRequests>>
>;
export type ReportOnSiteTotalRequestsQueryError = Error;

export function useReportOnSiteTotalRequests<
  TData = Awaited<ReturnType<typeof reportOnSiteTotalRequests>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteTotalRequestsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteTotalRequests>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteTotalRequests>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteTotalRequests>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteTotalRequests<
  TData = Awaited<ReturnType<typeof reportOnSiteTotalRequests>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteTotalRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteTotalRequests>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteTotalRequests>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteTotalRequests>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteTotalRequests<
  TData = Awaited<ReturnType<typeof reportOnSiteTotalRequests>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteTotalRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteTotalRequests>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get total request sources
 */

export function useReportOnSiteTotalRequests<
  TData = Awaited<ReturnType<typeof reportOnSiteTotalRequests>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteTotalRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteTotalRequests>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteTotalRequestsQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getReportOnSiteTotalRequestsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteTotalRequests>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteTotalRequestsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteTotalRequests>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReportOnSiteTotalRequestsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportOnSiteTotalRequests>>> = ({
    signal,
  }) => reportOnSiteTotalRequests(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/reporting/total_requests`,
      operationId: 'app.controllers.reporting_controller.report_on_site_total_requests',
      operationName: 'reportOnSiteTotalRequests',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteTotalRequests>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteTotalRequestsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteTotalRequests>>
>;
export type ReportOnSiteTotalRequestsSuspenseQueryError = Error;

export function useReportOnSiteTotalRequestsSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteTotalRequests>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteTotalRequestsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteTotalRequests>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteTotalRequestsSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteTotalRequests>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteTotalRequestsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteTotalRequests>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteTotalRequestsSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteTotalRequests>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteTotalRequestsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteTotalRequests>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get total request sources
 */

export function useReportOnSiteTotalRequestsSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteTotalRequests>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteTotalRequestsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteTotalRequests>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteTotalRequestsSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
